export const moversRoutes = {
  movers: { proxy: 'movers', upstream: 'movers' },
} as const;
